import React from 'react';

import { StyledIcon } from '../StyledIcon';

export const Host = props => (
  <StyledIcon viewBox='0 0 24 24' a11yTitle='Host' {...props}>
    <path fill='none' stroke='#000' strokeWidth='2' d='M17,4 L18,4 L18,5 L17,5 L17,4 Z M3,1 L21,1 L21,23 L3,23 L3,1 Z M3,13 L21,13 L3,13 Z M3,18 L21,18 L3,18 Z M3,8 L21,8 L3,8 Z' />
  </StyledIcon>
);
